const stickers = {
  'stickers-breadcrumbs': 'Стикеры',
  'stickers-details-title': 'Стикер',
  'stickers-filter-title': 'Фильтр стикеров',
  'stickers-create-sidebar': 'Создать стикер',
  'stickers-preview-title': 'Предпросмотр стикера',
  'stickers-unpublish-used-notification': 'Нельзя снять с публикации стикер, привязанный к событию',
  'structures-source-stickers': 'Стикеры',
  'structures-source-sticker': 'Стикер',
};

export default stickers;
